import "./styles.scss";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useHamburger } from "context/hamburger";
import SiteLogo from "components/SiteLogo";
import Hamburger from "../Hamburger";
import { Menu } from "./components";
const Mobile = () => {
  const {
    isCompactContactOpen,
    isCategoriesOpen,
    isPaginationOpen,
    setIsCompactContactOpen,
    setIsCategoriesOpen,
    setIsPaginationOpen,
    isPricingOpen,
    setIsPricingOpen,
  } = useHamburger();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const isModalOpen =
    isCompactContactOpen ||
    isCategoriesOpen ||
    isPaginationOpen ||
    isPricingOpen;

  const modalOpenFn = isCompactContactOpen
    ? setIsCompactContactOpen
    : isCategoriesOpen
    ? setIsCategoriesOpen
    : isPaginationOpen
    ? setIsPaginationOpen
    : isPricingOpen
    ? setIsPricingOpen
    : null;
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 1);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("mobile-menu--open");
    } else {
      document.body.classList.remove("mobile-menu--open");
    }
    return () => document.body.classList.remove("mobile-menu--open");
  }, [isOpen]);
  return (
    <>
      <header
        className={clsx(
          "header-mobile",
          (isScrolled || isOpen || isModalOpen) && "header-mobile--scroll"
        )}
      >
        <div className="container-fluid">
          <div className="header-mobile__logo">
            <SiteLogo isLight />
            <SiteLogo />
          </div>
          <div className="header-mobile__toggle">
            <Hamburger
              isOpen={isOpen || isModalOpen}
              isLight={!isScrolled && !isOpen && !isModalOpen}
              onClick={
                isModalOpen
                  ? () => modalOpenFn(false)
                  : () => setIsOpen((prevOpen) => !prevOpen)
              }
            />
          </div>
        </div>
      </header>
      <Menu isOpen={isOpen} isContactOpen={isCompactContactOpen} />
    </>
  );
};
export default Mobile;
